const StorageKeys = {
  AUTH_KEY: "AUTH_KEY",
  REFRESH_KEY: "REFRESH_KEY",
  CLIENT_ID: "CLIENT_ID"
} as const

export const getAuthToken = () => localStorage.getItem(StorageKeys.AUTH_KEY)
export const getRefreshToken = () => localStorage.getItem(StorageKeys.REFRESH_KEY)

export function saveAuthTokens(authToken: string, refreshToken: string) {
  localStorage.setItem(StorageKeys.AUTH_KEY, authToken)
  localStorage.setItem(StorageKeys.REFRESH_KEY, refreshToken)
}

export function clearAuth() {
  localStorage.removeItem(StorageKeys.AUTH_KEY)
  localStorage.removeItem(StorageKeys.REFRESH_KEY)
}

// One id per browser so refresh tokens are tracked per device on the backend
// (a user logged in on both phone and desktop must not invalidate each other)
export function getOrCreateClientId(): string {
  let clientId = localStorage.getItem(StorageKeys.CLIENT_ID)
  if (!clientId) {
    clientId = `pakketransport-${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 8)}`
    localStorage.setItem(StorageKeys.CLIENT_ID, clientId)
  }
  return clientId
}
